import styled, { css, keyframes } from 'styled-components';
import { Form as unformForm } from '@unform/web';

const bgDark = '#121212';
const cardDark = '#1E1E1E';
const textLight = '#EAEAEA';
const textSecondary = '#A0A0A0';
const border = 'rgba(255,255,255,0.1)';
const green = '#1DB954';
const amber = '#FFC107';
const red = '#dc3545';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${bgDark};
  color: ${textLight};
  align-items: center;
  width: 100%;
  overflow-x: hidden;
  * { box-sizing: border-box; }
`;

export const Form = styled(unformForm)`
  width: 100%;
  max-width: 1080px;
  margin: 120px auto 0 auto;
  display: flex;
`;

const appear = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 24px auto 40px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 800;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;
  @media (min-width: 768px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (min-width: 1024px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
`;

export const StatCard = styled.div`
  background: ${cardDark};
  border: 1px solid ${border};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: ${appear} 0.3s ease both;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: ${textSecondary};
`;

export const StatValue = styled.div<{ color?: 'green' | 'amber' | 'red' }>`
  font-size: 26px;
  font-weight: 700;
  ${(p) => p.color === 'green' && css`color: ${green};`}
  ${(p) => p.color === 'amber' && css`color: ${amber};`}
  ${(p) => p.color === 'red' && css`color: ${red};`}
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  @media (min-width: 1024px) { grid-template-columns: 1fr 1fr; }
`;

export const ChartCard = styled.div`
  background: ${cardDark};
  border: 1px solid ${border};
  border-radius: 12px;
  padding: 16px;
`;

export const ChartTitle = styled.h3`
  margin: 4px 0 12px 0;
  color: ${textLight};
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const FileButton = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background: ${amber};
  color: #000;
  border-radius: 8px;
  cursor: pointer;
`;

export const FileName = styled.span`
  color: ${textSecondary};
  font-size: 14px;
`;

const primary = '#256af4';
export const PrimaryButton = styled.button<{ variant?: 'primary' | 'green' }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${(p) => (p.variant === 'primary' ? primary : green)};
  color: ${(p) => (p.variant === 'primary' ? '#fff' : '#000')};
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 700;
  white-space: nowrap;
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
`;
